/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
// import { getLocalDateInFormat } from '../../utils/dateUtils';
import { Table, Tag, message } from 'antd';
import { find, get, map, remove } from 'lodash-es';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { useQueueUsersForCharger } from 'utils/queries/corporateQueue';
import Title from 'antd/lib/typography/Title';
import { formatDate } from 'utils/dateUtils';
import { Button } from 'reactstrap';
import AddToQueueModel from '../AddToQueueModel';
import { useRemoveUserFromQueueOfCharger } from 'utils/queries/corporateQueue';
import { getIST } from 'utils/dateUtils';
import { localDate } from 'utils/misc';

export default function CorporateChargingQueue({
  cpid,
  chargerId,
  corporateId,
}) {
  const [isAddToQueueOpen, setAddToQueueOpen] = useState(false);
  const [qidToDelete, setqidToDelete] = useState('');
  const { data: users, isLoading, refetch } = useQueueUsersForCharger(cpid);
  const { data: removeUserData, isLoadingRemoveUser } =
    useRemoveUserFromQueueOfCharger(qidToDelete);

  useEffect(() => {
    if (removeUserData) {
      console.log(removeUserData);
      message.success(removeUserData?.message);
      refetch();
    }
  }, [removeUserData, refetch]);

  const onDelete = (qid) => {
    if (qid) {
      setqidToDelete(qid);
    }
  };

  const columns = [
    {
      title: 'Position',
      dataIndex: 'POSITION',
      render: (text, user) => <>{user?.POSITION}</>,
      key: 'POSITION',
    },
    // {
    //   title: 'CUSTOMER ID',
    //   dataIndex: 'CUSTOMER_ID',
    //   render: (text, user) => <>{get(user, 'CUSTOMER_ID')}</>,
    //   key: 'CUSTOMER_ID',
    // },
    {
      title: 'Name',
      dataIndex: 'NAME',
      render: (text, user) => <>{get(user, 'NAME')}</>,
      key: 'NAME',
    },
    {
      title: 'Email',
      dataIndex: 'EMAIL',
      render: (text, user) => <>{get(user, 'EMAIL')}</>,
      key: 'EMAIL',
    },
    {
      title: 'PHONE_NUMBER',
      dataIndex: 'PHONE_NUMBER',
      render: (text, user) => <>{get(user, 'PHONE_NUMBER')}</>,
      key: 'PHONE_NUMBER',
    },
    {
      title: 'Queued at',
      dataIndex: 'QUEUED_AT',
      render: (text, user) => (
        <>{localDate(getIST(get(user, 'QUEUED_AT')).toString())}</>
      ),
      key: 'QUEUED_AT',
    },
    {
      title: 'Status',
      dataIndex: 'STATUS',
      render: (text, user) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: 5,
            border: '1px solid #525f7f',
            borderRadius: 10,
          }}
        >
          {get(user, 'STATUS')}
        </div>
      ),
      key: 'STATUS',
    },
    {
      title: 'NOTIFIED AT',
      dataIndex: 'NOTIFIED_AT',
      render: (text, user) => (
        <>
          {get(user, 'NOTIFIED_AT')
            ? localDate(getIST(get(user, 'NOTIFIED_AT')).toString())
            : '-'}
        </>
      ),
      key: 'NOTIFIED_AT',
    },
    {
      title: 'Actions',
      dataIndex: '',
      render: (name, user) => (
        <>
          <DeleteOutlined
            style={{ cursor: 'pointer' }}
            onClick={() => {
              onDelete(user?.ID);
            }}
          />
        </>
      ),
      key: '',
      width: 260,
    },
  ];

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div>
        <Title level={4}>Charging Queue</Title>
      </div>
      <Button
        style={{
          backgroundColor: '#2675b8',
          color: 'white',
          border: '0px solid transparent',
          paddingTop: '10px',
          paddingBottom: '10px',
          paddingLeft: '15px',
          paddingRight: '15px',
          borderRadius: '6px',
          marginBottom: '0px',
          height: '41px',
          marginRight: '10px',
          fontSize: '14px',
          fontWeight: 600,
        }}
        onClick={() => setAddToQueueOpen(true)}
      >
        Add to Queue
      </Button>
    </div>
  );

  const closeAddToQueue = () => {
    setAddToQueueOpen(false);
  };

  return (
    <>
      {
        // users?.length > 0 && (
        <Table
          rowKey="key"
          columns={columns}
          dataSource={users?.length > 0 ? users : []}
          pagination={false}
          title={() => getTitle()}
          bordered
        />
        // )
      }
      <AddToQueueModel
        isModalVisible={isAddToQueueOpen}
        closeAddToQueue={closeAddToQueue}
        corporateId={corporateId}
        chargerId={chargerId}
        triggerRefreshList={refetch}
      />
    </>
  );
}
